export interface Error {
	code: string;
	message?: string;
	data?: any;
	source?: {
		parameters?: string[];
		[K: string]: any;
	};
	[K: string]: any;
}

export const isError = (error: unknown): error is Error => typeof error === 'object' && error !== null && 'code' in error;
export const isErrorArray = (errors: unknown): errors is Error[] => Array.isArray(errors) && errors.every(isError);
